# Nutrição: Dieta, Porções & Hábitos Alimentares

O que o seu animal come influencia a energia, o peso, o pelo e a saúde a longo prazo. Porções consistentes, ingredientes de qualidade e refeições regulares fazem a maior diferença.

<ArticleImage
  src="/images/guide/food-pet-bowl.jpg"
  alt="Tigela de refeição equilibrada para pets"
  caption="Porções e consistência importam tanto quanto os ingredientes."
/>

---

<Section emoji="⚖️" title="Porções & Condição Corporal">

<Tip label="Meça as refeições" text="Use medidor ou balança para evitar excesso de comida com o tempo." />
<Tip label="Observe o formato" text="As costelas devem ser fáceis de sentir e a cintura levemente visível de cima." />
<Tip label="Orçamento de petiscos" text="Mantenha petiscos abaixo de 10% das calorias diárias." />

</Section>

<ArticleImage
  src="/images/guide/food-rabbit.jpg"
  alt="Refeição equilibrada em um prato"
  caption="Uma tigela equilibrada inclui proteína, fibras e gorduras essenciais."
/>

<Section emoji="🥩" title="Escolha a Dieta Certa">

<Tip label="Fase de vida" text="Filhotes, adultos e idosos precisam de perfis nutricionais diferentes." />
<Tip label="Necessidades de saúde" text="Questões renais, alergias ou peso geralmente exigem dietas orientadas pelo veterinário." />
<Tip label="Consistência" text="Mantenha marcas e fórmulas estáveis para reduzir desconforto gastrointestinal." />

<Callout>
Se você está considerando dieta crua ou caseira, converse com seu veterinário para garantir que seja completa e segura.
</Callout>

</Section>

<ArticleImage
  src="/images/guide/food-pet-water.jpg"
  alt="Copo de água"
  caption="Hidratação ajuda a digestão e a saúde urinária."
/>

<Section emoji="💧" title="Hidratação & Petiscos Inteligentes">

<Tip label="Água fresca" text="Troque a água diariamente e adicione tigelas extras em casas com vários pets." />
<Tip label="Gatos precisam de umidade" text="Ração úmida ou fontes de água podem ajudar os gatos a beber mais." />
<Tip label="Alimentos a evitar" text="Mantenha chocolate, uvas/passas, cebola e xilitol longe dos pets." />

</Section>

<Disclaimer title="⚠️ Lembrete Amigável">
Este guia é educativo e não substitui orientação veterinária. Mudanças súbitas no apetite, vômitos ou diarreia devem ser discutidos com seu veterinário.
</Disclaimer>
